import { Component } from "react"
import PropTypes from "prop-types"
import SolutionLottieAnimation from "./solution_lottie_animation"

export default class SolutionAnimation extends Component {
  render() {
    const { lottieJson } = this.props

    return (
      <SolutionLottieAnimation
        animationId="solution-animation"
        lottieJson={lottieJson}
      />
    )
  }
}

SolutionAnimation.propTypes = {
  lottieJson: PropTypes.string.isRequired,
}
